import { combineReducers } from 'redux';
import context from './context/reducer.tsx';
import entities from './entities/reducer.tsx';
import ui from './ui/reducer.tsx';

export default combineReducers({ context, ui, entities });
